import axios from "axios";
import { BASE_URL } from "../constants/Constants";


// Google login
export const loginWithGoogle = async (code) => {
  return axios.post(`${BASE_URL}/auth/google`, { code }, {
    headers: { "Content-Type": "application/json" }
  });
};

// MojoAuth login
export const loginWithMojoAuth = async (access_token) => {
  return axios.post(`${BASE_URL}/auth/mojoauth`, { access_token }, {
    headers: { "Content-Type": "application/json" }
  });
};

// Google: validate token
export const validateGoogleToken = (token) => {
  return axios.post(`${BASE_URL}/auth/validate-token`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

// Google: refresh token
export const refreshGoogleToken = (refreshToken) => {
  return axios.post(`${BASE_URL}/auth/refresh-token`, { refresh_token: refreshToken });
};

// MojoAuth: validate token
export const validateMojoToken = (token) => {
  return axios.post(`${BASE_URL}/auth/mojoauth/validate`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

// MojoAuth: refresh token
export const refreshMojoToken = (refreshToken) => {
  return axios.post(`${BASE_URL}/auth/mojoauth/refresh`, { refresh_token: refreshToken });
};